<app-page-header title="Mis consultas" subtitle="Historial de tus consultas legales"></app-page-header>

<div class="legal-queries-page">

    <main class="queries-main">

        <section class="queries-list" *ngIf="consultas.length > 0">
            <article class="query-card" *ngFor="let consulta of consultas">
                <div class="query-body">
                    <h3 class="query-title">{{ consulta.titulo }}</h3>

                    <div class="query-meta">
                        <span class="query-meta-item" *ngIf="consulta.fechaApertura">
                            <span class="query-meta-icon" aria-hidden="true">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="5" width="18" height="16" rx="2" stroke="#36424a" stroke-width="1.6"/>
                                    <path d="M8 3v4M16 3v4M3 10h18" stroke="#36424a" stroke-width="1.6" stroke-linecap="round"/>
                                </svg>
                            </span>
                            <span class="query-meta-text">Apertura: {{ consulta.fechaApertura }}</span>
                        </span>

                        <span class="query-meta-divider" aria-hidden="true"
                              *ngIf="consulta.fechaApertura && consulta.abogado"></span>

                        <span class="query-meta-item" *ngIf="consulta.abogado">
                            <span class="query-meta-icon" aria-hidden="true">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="8" r="4" stroke="#36424a" stroke-width="1.6"/>
                                    <path d="M4 21c0-4 4-7 8-7s8 3 8 7" stroke="#36424a" stroke-width="1.6" stroke-linecap="round"/>
                                </svg>
                            </span>
                            <span class="query-meta-text">Abogado: {{ consulta.abogado }}</span>
                        </span>
                    </div>
                </div>

                <div class="query-actions">
                    <button type="button" class="btn-ver-consulta" (click)="irDetalle(consulta)">
                        Ver consulta
                    </button>
                </div>
            </article>
        </section>

        <div class="empty-state" *ngIf="!loading && consultas.length === 0">
            <p>No tienes consultas legales registradas.</p>
        </div>

        <div class="loading-state" *ngIf="loading && consultas.length === 0">
            <p>Cargando consultas<span>.</span><span>.</span><span>.</span></p>
        </div>

    </main>

    <app-modal-dialog [show]="detailOpen"
                      title="Resolución de la consulta"
                      [width]="624"
                      (closed)="closeDetail()">
        <div class="lq-detail" *ngIf="selectedConsulta">
            <h4 class="lq-detail-title">{{ selectedConsulta.titulo }}</h4>
            <p class="lq-detail-desc">{{ selectedConsulta.descripcion }}</p>
        </div>
    </app-modal-dialog>

</div>

<app-footer></app-footer>
